// extracted by mini-css-extract-plugin
export default {"root":"Templates_root__TMZX3","row":"Templates_row__xyf+6","section":"Templates_section__HSCK3"};